import { PapiOrderV3, PapiSubscriptionV3 } from '@wix/da-papi-types';
import { AppState } from '../types/store';

export const getCardsV3 = (state: AppState) => state?.account?.cardsV3 ?? [];

export const getOrdersV3 = (state: AppState) => state?.account?.ordersV3 ?? [];

export const getOrderV3ByOrderId = (state: AppState, orderId: number): PapiOrderV3 | undefined =>
  getOrdersV3(state).find(o => o.transactionResult?.orderId === orderId);

export const getCoreSubscriptionV3 = (state: AppState) => state?.account?.coreSubscriptionV3;

export const getSubscriptionsV3 = (state: AppState): PapiSubscriptionV3[] =>
  state?.account?.subscriptionsV3 ?? [];

export const getActiveSubscriptionsV3 = (state: AppState): PapiSubscriptionV3[] =>
  getSubscriptionsV3(state).filter(s => s.isActive);

export const getSubscriptionByTierIdV3 = (
  state: AppState,
  tierId: number
): PapiSubscriptionV3 | undefined =>
  getSubscriptionsV3(state).find(s => s.orderV3?.product.deviation?.deviationId === tierId);

export const getSubscriptionByOrderIdV3 = (
  state: AppState,
  orderId: number
): PapiSubscriptionV3 | undefined => {
  const coreSubscription = getCoreSubscriptionV3(state);
  return coreSubscription?.orderId === orderId
    ? coreSubscription
    : getSubscriptionsV3(state).find(s => s.orderId === orderId);
};

export const getInitialTierId = (state: AppState) => state.account?.initialTierId;

export const getCountries = (state: AppState) => state?.account?.countries ?? [];

export const getStates = (state: AppState) => state?.account?.states ?? [];
